<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search" /></el-button-group>

    <el-table :data="freightTemplates" resource="freight-templates">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.details" style="width: 100%">
            <el-table-column label="运送方式">
              <template slot-scope="scope">
                <span v-if="scope.row.delivery_type === 0">快递</span>
                <span v-else>快递公司</span>
              </template>
            </el-table-column>
            <el-table-column prop="area_desc" label="配送至">
              <template slot-scope="scope">
                <span v-if="scope.row.is_default === true">中国</span>
                <span v-else>{{ area_desc }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="first_item" :label="props.row.valuation_way === 0 ? '首件（件）' : '首重（g）'" />
            <el-table-column prop="first_freight" label="运费（元）" />
            <el-table-column prop="next_item" :label="props.row.valuation_way === 0 ? '续件（件）' : '续重（g）'" />
            <el-table-column prop="next_freight" label="运费（元）" />
            <el-table-column prop="area_desc" label="免邮条件">
              <template slot-scope="scope">
                <span v-if="scope.row.free_freight_item > 0">满{{ scope.row.free_freight_item }}件免邮</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="name" label="模板名称" />
      <el-table-column prop="valuation_way_text" label="计价方式" />
      <el-table-column label="是否默认">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_default" disabled />
        </template>
      </el-table-column>
      <el-table-column label="是否包邮">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_shipping_free" disabled />
        </template>
      </el-table-column>

      <!-- <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import { getFreightTemplates } from '@/api/freight-templates';
// import RowDestroy from '@c/LzTable/RowDestroy'
// import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    // RowToEdit,
    // RowDestroy,
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          field: 'name',
          label: '模版名称(模糊)'
        }
      ],
      freightTemplates: [],
      page: null
    };
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta }
        } = await getFreightTemplates(newVal.query);
        this.freightTemplates = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
